import { inject, Injectable, OnDestroy } from '@angular/core';
import { LocalStorageService } from '../storage/local-storage.service';
import { BoelsUserTypeEnum, StorageKey } from '@boels/models';
import { Observable, Subject } from 'rxjs';
import { CookieService } from '../cookie/cookie.service';

@Injectable({
  providedIn: 'root',
})
export class UserTypeService implements OnDestroy {
  #localStorageService = inject(LocalStorageService);
  #cookieService = inject(CookieService);
  userTypeChanged = new Subject<BoelsUserTypeEnum>();

  ngOnDestroy(): void {
    this.userTypeChanged.complete();
  }

  /**
   * Check if user type is selected
   */
  isUserTypeSelected(): boolean {
    return Boolean(BoelsUserTypeEnum[<BoelsUserTypeEnum>this.getUserType()]);
  }
  /**
   * Check if user type is individual
   */
  isIndividualUser(): boolean {
    return this.getUserType() === BoelsUserTypeEnum.INDIVIDUAL;
  }
  /**
   * Set user type in local storage
   * @param userType
   */
  setUserType(
    userType: BoelsUserTypeEnum,
    storageKey:
      | StorageKey.USER_TYPE
      | StorageKey.TEMP_USER_TYPE = StorageKey.USER_TYPE,
  ): void {
    // Keep both user type and temp user type
    this.#localStorageService.setItem(storageKey, userType);
    if (storageKey == StorageKey.TEMP_USER_TYPE) return;

    this.#cookieService.setCookie(StorageKey.USER_TYPE, userType, 3000);
    this.userTypeChanged.next(userType);
  }
  /**
   * Get user type from local storage
   */
  getUserType(
    storageKey:
      | StorageKey.USER_TYPE
      | StorageKey.TEMP_USER_TYPE = StorageKey.USER_TYPE,
  ): BoelsUserTypeEnum | undefined {
    let userType = this.#localStorageService.getItem<
      BoelsUserTypeEnum | undefined
    >(storageKey);
    if (storageKey == StorageKey.TEMP_USER_TYPE) return userType;

    if (!userType) {
      const cookieUserType = this.#cookieService.getCookie(
        StorageKey.USER_TYPE,
      );
      userType = cookieUserType ? <BoelsUserTypeEnum>cookieUserType : undefined;
    }
    return userType;
  }
  /**
   * Subscribe to user type changes
   */
  onUserTypeChange(): Observable<BoelsUserTypeEnum> {
    return this.userTypeChanged.asObservable();
  }
}
